<header class="flex header">
  <h2>
    @if (user) {
      {{ 'Update' | translateWF: 'Update' }}
    } @else {
      {{ 'Add' | translateWF: 'Add' }}
    }
    {{ 'Users_Table_Title_User' | translateWF: 'User' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<div class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label for="">{{ 'User_Modal_Username' | translateWF: 'Username' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="userName" />
      </div>
      <div class="form-box">
        <label for="">{{ 'User_Modal_Email' | translateWF: 'Email' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="email" />
      </div>
      <div class="form-box">
        <label for="">{{ 'User_Modal_Password' | translateWF: 'Password' }}</label>
        @if (editPassword()) {
          <div class="content-row pb-3">
            <p-password class="w-full mb-3" id="passwordLogin" [formControl]="password" [toggleMask]="true" [feedback]="false" />
          </div>
          <p-button label="{{ 'Generate' | translateWF: 'Generate' }}" severity="success" (onClick)="generateAutomaticPassword()" />
        } @else {
          <small>{{ 'User_Modal_Edit_Password_Hint' | translateWF: 'Set a new password for this user.' }}</small>
          <div class="content-row">
            <p-button [label]="'User_Modal_Edit_Password' | translateWF: 'Edit Password'" severity="secondary" (onClick)="editPassword.set(true)" />
          </div>
        }
      </div>

      <p-divider />

      <div class="form-box">
        <label for="">{{ 'User_Modal_FirstName' | translateWF: 'First Name' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="firstName" />
      </div>
      <div class="form-box">
        <label for="">{{ 'User_Modal_MiddleName' | translateWF: 'Middle Name' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="middleName" />
      </div>
      <div class="form-box">
        <label for="">{{ 'User_Modal_LastName' | translateWF: 'Last Name' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="lastName" />
      </div>
      <div class="form-box">
        <label for="">{{ 'User_Modal_Second_LastName' | translateWF: 'Second Last Name' }}</label>
        <input type="text" pInputText class="cs-fill-width" [formControl]="secondLastName" />
      </div>
      <div class="form-box">
        <label for="">Avatar</label>
        <div class="content-row">
          <p-button label="{{ 'User_Modal_Choose' | translateWF: 'Choose' }}" severity="success" icon="pi pi-upload" (click)="uploadAvatar.click()" />
          <input type="file" accept="image/*" #uploadAvatar style="display: none" />
          <p>File name.jpg</p>
        </div>
      </div>

      <p-divider />

      @if (canAssignSites) {
        <div class="form-box">
          <label for="">{{ 'Sites' | translateWF: 'Sites' }}</label>
          <p-multiSelect
            appendTo="body"
            [options]="availableSites"
            optionLabel="name"
            optionValue="id"
            [ngModel]="selectedSiteIds"
            (ngModelChange)="onSitesChange($event)"
            display="chip"
            placeholder="Select sites"
            class="cs-fill-width"
          ></p-multiSelect>
          @if (submittedForm && selectedSiteIds.length === 0) {
            <small class="text-red-500">At least one site must be selected.</small>
          }
        </div>

        @if (sitePanels.length > 0) {
          <p-divider />
          <p-accordion [multiple]="true" [(value)]="expandedSiteIds">
            @for (panel of sitePanels; track panel.siteId) {
              <p-accordion-panel [value]="panel.siteId">
                <p-accordion-header>{{ getSiteName(panel.siteId) }}</p-accordion-header>
                <p-accordion-content>
                  <div class="flex flex-col gap-4">
                    <label for="">Group</label>
                    <p-pickList
                      [source]="panel.availableGroups"
                      [target]="panel.selectedGroups"
                      sourceHeader="Available Groups"
                      targetHeader="Selected Groups"
                      [responsive]="true"
                      filterBy="name"
                      sourceFilterPlaceholder="Search available"
                      targetFilterPlaceholder="Search selected"
                      (onMoveToTarget)="onPanelGroupsChanged(panel)"
                      (onMoveToSource)="onPanelGroupsChanged(panel)"
                      (onMoveAllToTarget)="onPanelGroupsChanged(panel)"
                      (onMoveAllToSource)="onPanelGroupsChanged(panel)"
                      [showSourceControls]="false"
                      [showTargetControls]="false"
                    >
                      <ng-template let-group pTemplate="item">
                        <div>{{ group.name }}</div>
                      </ng-template>
                    </p-pickList>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        }
      } @else {
        @if (isDelegate()) {
          <!-- Delegated user manager (#6263): the active site, read-only; only delegable groups are listed. -->
          <p-message severity="secondary" icon="pi pi-map-marker">
            <strong>{{ 'User_Modal_Site' | translateWF: 'Site' }}:</strong>&nbsp;{{ activeSiteName }}
          </p-message>
        }
        <div class="form-box">
          <label for="">Group</label>
          @if (isDelegate()) {
            <small>{{ 'User_Modal_Delegate_Groups_Hint' | translateWF: 'Only groups marked as visible to external managers are listed.' }}</small>
            @if (hasHiddenGroups()) {
              <p-message severity="info" icon="pi pi-eye-slash">
                {{
                  'User_Modal_Hidden_Groups'
                    | translateWF: 'There are other groups assigned but not visible, please contact nexus.support@card-software.com if you want more information.'
                }}
              </p-message>
            }
          }
          <p-pickList
            [source]="allGroups"
            [target]="selectedGroups"
            sourceHeader="Available Groups"
            targetHeader="Selected Groups"
            [responsive]="true"
            filterBy="name"
            sourceFilterPlaceholder="Search available"
            targetFilterPlaceholder="Search selected"
            (onMoveToTarget)="onSingleSiteGroupsChanged()"
            (onMoveToSource)="onSingleSiteGroupsChanged()"
            (onMoveAllToTarget)="onSingleSiteGroupsChanged()"
            (onMoveAllToSource)="onSingleSiteGroupsChanged()"
            [showSourceControls]="false"
            [showTargetControls]="false"
          >
            <ng-template let-group pTemplate="item">
              <div>{{ group.name }}</div>
            </ng-template>
          </p-pickList>
        </div>
      }

      <p-divider />

      <div class="form-box">
        <label for="">{{ 'User_Modal_Status' | translateWF: 'Status' }}</label>
        <p-select [options]="listStatus()" optionLabel="label" optionValue="value" [formControl]="status" styleClass="cs-fill-width" />
      </div>
      <div class="form-box">
        <div class="flex items-center gap-2">
          <p-checkbox inputId="userIsExternallyManaged" [binary]="true" [formControl]="externallyManaged" />
          <label for="userIsExternallyManaged">{{ 'User_Modal_ExternallyManaged' | translateWF: 'Managed by external admins' }}</label>
        </div>
        <small>
          @if (isDelegate()) {
            {{ 'User_Modal_ExternallyManaged_Delegate_Hint' | translateWF: 'Users you create are always managed by external admins.' }}
          } @else {
            {{
              'User_Modal_ExternallyManaged_Hint'
                | translateWF: 'External admins can manage this user while they belong to one site, have no direct roles and only groups visible to external managers.'
            }}
          }
        </small>
      </div>
    </div>
  </p-card>
</div>

<footer>
  <p-button class="cs-fill-width" label="{{ 'Save' | translateWF: 'Save' }}" (click)="onSubmit()" [disabled]="blockButton()" />
  <p-button class="cs-fill-width" label="{{ 'Exit' | translateWF: 'Exit' }}" variant="outlined" (click)="onClose()" />
</footer>
